<template>
    <div class="min-h-screen bg-gradient-to-b from-teal-50 to-white flex flex-col justify-center items-center px-4">
      <div class="mb-8 text-center">
        <img src="@/assets/main-logo.png" alt="Magnum Dental Logo" class="w-20 h-20 mx-auto mb-2" />
        <h1 class="text-2xl font-bold text-teal-800 font-serif">MAGNUM DENTAL</h1>
      </div>
  
      <form @submit.prevent="login" class="bg-white shadow-lg rounded-lg p-8 w-full max-w-sm space-y-4">
        <h2 class="text-xl font-bold text-center text-gray-800">Login</h2>
        <input
          v-model="username"
          type="text"
          placeholder="Username"
          class="w-full border border-gray-300 px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-teal-500"
        />
        <input
          v-model="password"
          type="password"
          placeholder="Password"
          class="w-full border border-gray-300 px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-teal-500"
        />
        <button
          type="submit"
          class="w-full bg-teal-600 text-white py-2 rounded hover:bg-teal-700 transition"
        >
          Log In
        </button>
        <p v-if="error" class="text-red-500 text-sm text-center">{{ error }}</p>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginView',
    data() {
      return {
        username: '',
        password: '',
        error: ''
      };
    },
    methods: {
      login() {
        if (this.username === 'admin' && this.password === 'pass999') {
          localStorage.setItem('loggedIn', 'true');
          this.$router.push('/dashboard');
        } else {
          this.error = 'Invalid credentials';
        }
      }
    }
  };
  </script>
  